import React from 'react';

const ContactTab = ({ formData, onChange }) => {
    return (
        <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-medium font-montserrat text-gray-900 mb-4">Kontakt information</h2>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Telefon</label>
                    <input
                        type="tel"
                        value={formData.phone}
                        onChange={(e) => onChange('phone', e.target.value)}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="+45 12345678"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Email</label>
                    <input
                        type="email"
                        value={formData.email}
                        onChange={(e) => onChange('email', e.target.value)}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="firma@email.dk"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Adresse</label>
                    <input
                        type="text"
                        value={formData.address}
                        onChange={(e) => onChange('address', e.target.value)}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="Gade og husnummer"
                    />
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Postnummer</label>
                        <input
                            type="text"
                            value={formData.zipcode}
                            onChange={(e) => onChange('zipcode', e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            placeholder="1234"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">By</label>
                        <input
                            type="text"
                            value={formData.city}
                            onChange={(e) => onChange('city', e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            placeholder="København"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactTab;